// extracted by mini-css-extract-plugin
module.exports = {"link-creating-sales-type":"D2IlIbEpIV8HUW-oRmV-H"};